import React, { useContext, useState } from 'react';
import { SourceResponseModal } from '../../components/SourceResponseModal';
import { SessionContext } from '../../contexts/SessionContext';

const ViewSource = (props: any) => {
  const { list } = props;
  const [sourceResponseModAL, setSourceResponseModAL] = useState<boolean>(false);
  const [linked, setLinked] = useState<boolean>(false);
  const [hover, sethover] = useState<boolean>(false);
  const { isPromptGenerating } = useContext(SessionContext);

  const handleTablet = () => {
    if (list?.action == 'link') {
      setLinked(true);
    }
    if (list?.action == 'hover') {
      sethover(true);
    }
    if (list?.action == 'Popup') {
      setSourceResponseModAL(true);
    }
  };

  return (
    <>
      <div className="flex flex-wrap gap-6 justify-center items-center cursor-pointer" onClick={handleTablet}>
        <a
          className="border border-[#EEEEEE] rounded-full px-2 h-5 font-xs bg-white text-[#737373] hover:border-[#A100FF]
          flex justify-center items-center leading-[0]"
          href={linked ? list?.link : null}
          target="_blank"
          rel="noreferrer"
        >
          {list?.dataSource?.length > 10 ? `${list?.dataSource?.slice(0, 14)}...` : list?.dataSource}
        </a>
      </div>
      {sourceResponseModAL ? (
        <SourceResponseModal
          sourceResponseModAL={sourceResponseModAL}
          setSourceResponseModAL={setSourceResponseModAL}
          list={list}
        />
      ) : null}
    </>
  );
};

export default ViewSource;
